import { colorSet } from '@components/Provider';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  'Connect-Drive-Dialog-root': {
    padding: 32,
    maxWidth: 720,
    borderRadius: 16,
    '& .connect-logo': {
      marginBottom: 20
    }
  },
  'Connect-Drive-Dropzone-root': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: 487,
    border: `2px dashed ${colorSet.gray400}`,
    borderRadius: 16,
    '& .inner_box': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      width: 279,
      height: 160,
      '& .file_upload_icon': {
        marginBottom: 8
      }
    }
  },
  'Connect-Drive-Bottom-CTA': {
    marginTop: 24,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',

    [theme.breakpoints.down('xs')]: {
      marginTop: 16
    },

    '& button': {
      width: 132,
      [theme.breakpoints.down('xs')]: {
        width: '100%'
      }
    },
    '& .cancel': {
      color: colorSet.gray900,
      marginRight: 8
    }
  },
  'Connect-Drive-List-Root': {
    width: '100%',
    '& .list-empty': {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: 366
    },
    '& .MuiBreadcrumbs-root': {
      height: 26,
      '& .MuiBreadcrumbs-separator': {
        '& svg': {
          width: 16,
          height: 16,
          color: colorSet.gray900
        }
      },
      '& .breadcrumb-item': {
        ...theme.typography.subtitle2,
        color: colorSet.gray900,
        '&.selected': {
          fontWeight: 'bold'
        }
      },
      '& .MuiBreadcrumbs-ol': {
        height: '100%'
      },
      '& .MuiBreadcrumbs-li': {
        display: 'flex',
        alignItems: 'center'
      }
    },
    '& .list-header': {
      display: 'flex',
      padding: '10px 0px',
      borderTop: `1px solid ${colorSet.gray200}`,
      borderBottom: `1px solid ${colorSet.gray200}`,
      '& .list-header-fileName': {
        maxWidth: 380,
        width: '100%'
      },
      '& .list-header-uploadedAt': {
        maxWidth: 120,
        marginLeft: 20,
        marginRight: 20,
        width: '100%'
      },
      '& .list-header-fileSize': {
        width: '100%',
        maxWidth: 120
      }
    },
    '& .list-container': {
      height: 366,
      overflowY: 'scroll'
    },
    '& .list-items': {
      display: 'flex',
      alignItems: 'center',
      padding: 12,
      borderBottom: `1px solid ${colorSet.gray200}`,
      [theme.breakpoints.down('xs')]: {
        padding: '6px 0px',
        justifyContent: 'space-between',
        borderTop: `1px solid ${colorSet.gray200}`
      },
      '& .group': {
        display: 'flex',
        alignItems: 'center',
        width: 368,
        [theme.breakpoints.down('xs')]: {
          '& .mobile_group': {
            flexDirection: 'column',
            width: 187
          }
        }
      },
      '& .checkbox': {
        width: 20,
        height: 20,
        '& .MuiCheckbox-root': {
          padding: 0,
          width: 20,
          height: 20
        },
        [theme.breakpoints.down('xs')]: {
          marginRight: 10,
          width: 24,
          height: 24,
          '& .MuiCheckbox-root': {
            padding: 0,
            width: 24,
            height: 24
          }
        }
      },
      '& .thumbnail': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 36,
        height: 36,
        marginLeft: 16,
        marginRight: 16,
        '& img': {
          width: '100%'
        },
        [theme.breakpoints.down('xs')]: {
          width: 48,
          height: 48,
          marginLeft: 0,
          marginRight: 16,
          '& img': {
            width: 32
          }
        }
      },
      '& .fileName': {
        width: 219,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        [theme.breakpoints.down('xs')]: {
          width: 187
        }
      },
      '& .uploadedAt': {
        maxWidth: 120,
        marginLeft: 20,
        marginRight: 20,
        width: '100%'
      },
      '& .fileSize': {
        maxWidth: 120,
        width: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      },
      '&.selected': {
        backgroundColor: colorSet.primary100
      },
      '&.notMatch': {
        opacity: 0.2,
        backgroundColor: colorSet.gray100,

        '&:hover': {
          backgroundColor: colorSet.gray100,
          cursor: 'auto'
        }
      },
      '&:hover': {
        backgroundColor: colorSet.primary100,
        cursor: 'pointer'
      }
    }
  },
  'Connect-Drive-Upload-Button-root': {
    position: 'absolute',
    top: 34,
    right: 24,
    [theme.breakpoints.down('xs')]: {
      top: 20,
      right: 16,
      '& > button': {
        padding: 0
      }
    },
    '& input': {
      display: 'none'
    }
  },
  'Connect-Drive-Search-root': {
    backgroundColor: colorSet.gray100,
    borderRadius: 8,
    marginBottom: 16,
    '& .MuiInputBase-input': {
      paddingTop: 14,
      paddingBottom: 14
    },
    '& svg': {
      width: 20,
      height: 20,
      marginRight: 10
    },
    '& fieldset': {
      border: 'none'
    }
  }
}));

export default useStyles;
